import LisProject from "./LisProject";
export default LisProject;
